import { ReactNode, useState, useEffect } from "react"
import { BudgetDetailContext } from "./contexts/BudgetDetailContext"
import { useLoader } from "../hooks/useLoader"

import ApiService from "../services/ApiServiceClass";

export interface IBudgetDetailProviderProps {
    children: ReactNode
}

const BudgetDetailProvider = ({children}: IBudgetDetailProviderProps) => {
    const [budgetRemaining, setBudgetRemaining] = useState<number>(0);
    const [budgetSpent, setBudgetSpent] = useState<number>(0);
    const [totalRequest, setTotalRequest] = useState<number>(0);
    const [yearlyBudget, setYearlyBudget] = useState<number>(0);

    const loader = useLoader();

    const fetchBudgetDetails = async () => {
        loader?.setIsLoading(true);
        try {
            const responseData = await ApiService.getBudgetDetails();
            loader?.setIsLoading(false);

            setBudgetRemaining(responseData.data.budget_remaining);
            setBudgetSpent(responseData.data.budget_spending);
            setTotalRequest(responseData.data.total_request);
            setYearlyBudget(responseData.data.yearly_budget);

        } catch(error) {
            loader?.setIsLoading(false);
        }
    } 


    useEffect(() => {
        fetchBudgetDetails();
    }, [yearlyBudget]);
    return (
        <BudgetDetailContext.Provider value={{
            budgetRemaining,
            budgetSpent,
            totalRequest,
            yearlyBudget,
            setBudgetRemaining,
            setBudgetSpent,
            setTotalRequest,
            setYearlyBudget,
            fetchBudgetDetails
        }}>
            { children }
        </BudgetDetailContext.Provider>
    )
}

export default BudgetDetailProvider;